import React from 'react';
import AutoRouter from 'components/Router/AutoRouter';
import { paths } from 'routes/paths/client';

export default function ClientRouter() {
    return <AutoRouter routes={paths} />;
}
